import { combineEpics } from 'redux-observable';
import { closeSymbolClientBeforeRemoveEpic } from './_epics/closeSymbolClientBeforeRemove.epic';
import { handleSymbolClientNotFoundEpic } from './_epics/handleSymbolClientNotFound.epic';
import { reloadSymbolClientListEpic } from './_epics/reloadSymbolClientList.epic';
import { toggleViewSymbolClientSidebarEpic } from './_epics/toggleViewSymbolClientSidebar.epic';
import { closeBulkEditSidebarOnDoneEpic } from './_epics/closeBulkEditSidebarOnDone.epic';

export const controllerSymbolClientEpic = combineEpics(
  closeSymbolClientBeforeRemoveEpic,
  handleSymbolClientNotFoundEpic,
  reloadSymbolClientListEpic,
  toggleViewSymbolClientSidebarEpic,
  closeBulkEditSidebarOnDoneEpic,
);
